import {Marketer} from '../models/Marketer';
import {MarketerRepository} from '../repository/MarketerRepository';
import {Pagination} from '../../../Data/types/BaseResponse';

export class GetAllMarketersUseCase {
  constructor (private marketerRepository: MarketerRepository) {}

  async execute (page = 1, limit = 20, search?: string): Promise<{ items: Marketer[]; pagination?: Pagination }> {
    return this.marketerRepository.getAll(page, limit, search);
  }
}
